import { create } from "zustand";

const useRolesListStore = create((set) => ({
  rolesList: {
    allPA: [],
    allPFA: [],
    allCM: [],
    allSM: [],
    allFL: [],
    allML: [],
  },
  setRolesList: (roles) =>
    set((state) => ({
      rolesList: { ...state.rolesList, ...roles },
    })),
}));

export default useRolesListStore;
